import React from 'react';
import { Link } from 'react-router-dom';

const LandingPage: React.FC = () => {
    return (
        <div style={{ textAlign: 'center', padding: '50px' }}>
            <h1>Willkommen bei ProjectA</h1>
            <p>Dies ist die öffentliche Landingpage.</p>

            <div style={{ marginTop: '30px' }}>
                <Link to="/login" style={{
                    padding: '10px 20px',
                    backgroundColor: '#007bff',
                    color: 'white',
                    textDecoration: 'none',
                    borderRadius: '5px'
                }}>
                    Zum Login
                </Link>
            </div>
        </div>
    );
};

export default LandingPage;